// Grid geometry shared by the live grid, the page-break overlay and the PDF layout.
// This module has no imports, so the PDF code can read it without the widget registry.

/** Default grid configuration (matches react-grid-layout and current demo). */
export const DEFAULT_GRID_COLS = 12;
export const DEFAULT_ROW_HEIGHT = 30;
export const DEFAULT_GRID_MARGIN: [number, number] = [10, 10];
